export default __webpack_public_path__ + "static/media/02_south_flower_c2.4be76efa.mp4";